module.exports = __webpack_public_path__ + "img/D_tag.3210221c.png";